import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";
import logoLight from "../../assets/images/amblem_light.png";
import logoDark from "../../assets/images/amblemlight2.png";
import { useTheme } from "../../contexts/ThemeContext";
import { useLanguage } from "../../contexts/LanguageContext";

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();
  const { language, toggleLanguage, t } = useLanguage();

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  return (
    <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/" className="navbar-logo">
          <img
            src={theme === "light" ? logoLight : logoDark}
            alt="Has Gümüş  Logo"
            className="navbar-logo-image"
          />
        </Link>
        {/* Menü */}
        <div className={`navbar-menu ${isMenuOpen ? "menu-open" : ""}`}>
          <ul className="menu">
            <li>
              <Link
                to="/"
                className={`menu-item ${location.pathname === "/" ? "active" : ""}`}
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav.home')}
              </Link>
            </li>
            <li>
              <Link
                to="/bilgitoplum"
                className={`menu-item ${location.pathname === "/bilgitoplum" ? "active" : ""}`}
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav.bilgitoplum')}
              </Link>
            </li>
            <li>
              <Link
                to="/products"
                className={`menu-item ${location.pathname === "/products" ? "active" : ""}`}
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav.products')}
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className={`menu-item ${location.pathname === "/about" ? "active" : ""}`}
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav.about')}
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className={`menu-item ${location.pathname === "/contact" ? "active" : ""}`}
                onClick={() => setIsMenuOpen(false)}
              >
                {t('nav.contact')}
              </Link>
            </li>
          </ul>
        </div>
        {/* Theme, Language and Menu buttons */}
        <div className="navbar-right">
          <button
            className="theme-switcher"
            onClick={toggleTheme}
            aria-label={
              theme === "light" ? "Switch to dark mode" : "Switch to light mode"
            }
            title={theme === "light" ? "Karanlık Mod" : "Aydınlık Mod"}
          >
            {theme === "light" ? "🌙" : "☀️"}
          </button>
          <button
            className="language-switcher"
            onClick={toggleLanguage}
            aria-label={
              language === "tr" ? "Switch to English" : "Türkçe'ye Geç"
            }
            title={language === "tr" ? "English" : "Türkçe"}
          >
            {language === "tr" ? "EN" : "TR"}
          </button>
          <button
            className={`menu-toggle ${isMenuOpen ? "open" : ""}`}
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
          >
            <span className="menu-toggle-line" />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
